import jQuery from "jquery";
export default jQuery;
